<div class="flex flex-col px-6 pt-6 gap-3" data-testid="edit-patient-dialog">
  <div class="flex items-center justify-between">
    <h1 class="ml-10 headline-small text-primary flex-1 text-center" data-testid="edit-patient-dialog-title">{{ headerLabel | translate }}</h1>
    <button mat-icon-button
      appDialogClose
      [attr.aria-label]="'Close' | translate"
      data-testid="edit-patient-close-button">
      <mat-icon class="text-on-surface-variant">close</mat-icon>
    </button>
  </div>
  <div class="flex justify-center">
    <p class="body-medium text-on-surface-variant text-center w-[462px]" data-testid="edit-patient-description">{{ 'Add or update the patient for this consultation' | translate }}</p>
  </div>
</div>

<div class="flex-1 overflow-auto px-6 pt-6">
  <app-patient-selector [selectable]="true" [visitFlow]="isVisitSelectionEnabled" (patientSelected)="onPatientSelected($event)" (patientSourceSelected)="selectPatientSource($event)" data-testid="edit-patient-selector"></app-patient-selector>
</div>

<div class="px-6 pb-6">
  @if (isVisitSelectionEnabled) {
    <div class="flex items-center gap-3 pt-6 w-full">
      <button mat-stroked-button color="primary" class="h-12 rounded-[8px]" (click)="openManualPatient()"
        data-testid="edit-patient-manual-button">{{ (isCustom ? 'Edit current patient' : 'Add patient manually') | translate }}</button>
      <button mat-flat-button color="primary" class="h-12 rounded-[8px] ml-auto" [disabled]="!selectedPatient || isSubmitting"
        (click)="onContinue()" data-testid="edit-patient-update-button">{{ primaryActionLabel | translate }}</button>
    </div>
  } @else {
    <div class="flex flex-col gap-4 pt-6 w-full">
      <button mat-flat-button color="primary" class="w-full h-12" [disabled]="!selectedPatient || isSubmitting" (click)="onContinue()" data-testid="edit-patient-update-button">{{ 'Update patient' | translate }}</button>
      <button mat-button class="title-medium text-primary" (click)="openManualPatient()" data-testid="edit-patient-manual-button">{{ (isCustom ? 'Edit current patient' : 'Add patient manually') | translate }}</button>
    </div>
  }
</div>